import { useIsFetching, useIsMutating } from '@tanstack/react-query';
import Link from 'next/link';
import clsx from 'clsx';

import { LoadingAnimation } from '@assets';
import { withErrorHandler } from '@utils/errorHandler';

interface ICtaContainerProperties {
  blocked?: boolean;
  buttonText: string;
  children?: any;
  href?: string;
  loading?: boolean;
  muted?: boolean;
  onButtonClick?: (event: any) => void;
}

export const CtaContainer = ({
  blocked,
  buttonText,
  children,
  href,
  loading,
  muted,
  onButtonClick,
}: ICtaContainerProperties) => {
  const isFetching = useIsFetching();
  const isMutating = useIsMutating();
  const showLoadingIndicator = loading || isFetching || isMutating;

  return (
    <div className='ctaContainer' id='ctaContainer'>
      {children}
      {href && (
        <Link href={href}>
          <button
            className={clsx(
              'buttonProceed',
              (isFetching || isMutating) && 'blocked'
            )}
            id='buttonGetTickets'
            role='button'
            tabIndex={0}
          >
            {isFetching ? (
              <LoadingAnimation fill='#ffffff' height={20} />
            ) : (
              <h3>{buttonText}</h3>
            )}
          </button>
        </Link>
      )}
      {onButtonClick && (
        <button
          className={clsx(
            'buttonProceed',
            (blocked || loading || isFetching || isMutating) && 'blocked',
            muted && 'muted'
          )}
          onClick={onButtonClick && withErrorHandler(onButtonClick)}
        >
          {showLoadingIndicator ? (
            <LoadingAnimation
              fill='#ffffff'
              height={20}
              aria-label='Loading . . .'
            />
          ) : (
            <span>{buttonText}</span>
          )}
        </button>
      )}
    </div>
  );
};
